<template>
  <div v-if="isDoctorOrAssistant">
    <OpenedVisitHeader v-for="visit in visits"
                       :visit="visit"
                       :key="`v-${visit.id}`"/>
  </div>
</template>

<script setup>
import { computed } from "vue"
import { useStore } from "vuex"
import OpenedVisitHeader from "@/components/parts/patients/visit/OpenedVisitHeader.vue"

const store = useStore()

const isDoctorOrAssistant = computed(() => store.getters.isDoctorOrAssistant)
const visits = computed(() => store.state.treatment.myOpenedVisits)
</script>
